// extracted by mini-css-extract-plugin
export default {"iconImage":"styles_iconImage__U7Qdp","icon":"styles_icon__VWZQ0","detail":"styles_detail__LnTq1","text":"styles_text__CvNxj"};